import { basicInfoAtom, changeCarListAtom, destDetailAtom, shippingCompleteAtom, targetShippingSeqAtom } from '@/commons/constants';
import DestDetailPop from '../shipping/DestDetail';

import styled from 'styled-components';
import { Button } from '@mui/material';

import BeenhereIcon from '@mui/icons-material/Beenhere';
import DownloadIcon from '@mui/icons-material/Download';
import * as XLSX from 'xlsx';

import { useAtomValue, useSetAtom } from 'jotai';
import AllDestList from './AllDestList';
import BasicInfo from './BasicInfo';
import AllCarList from './AllCarList';
import AllOrderList from './AllOrderList';
import AllNotAssignList from './AllNotAssignList';
import { shippingComplete, shippingImportExcel, shippingTargetDetail } from '@/interfaces/plan/shipping';
import { useEffect } from 'react';

const ButtonAreaWrap = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
`;
export function Floating() {
  const destDetail = useAtomValue(destDetailAtom);
  const { data } = useAtomValue(shippingTargetDetail);
  const targetShippingSeq = useAtomValue(targetShippingSeqAtom);
  const setComplete = useSetAtom(shippingCompleteAtom);
  const complete = useAtomValue(shippingCompleteAtom);
  const changeCarList = useAtomValue(changeCarListAtom);
  const basicInfo = useAtomValue(basicInfoAtom);

  useEffect(() => {
    setComplete(data?.shipping?.use_flag === 1);
  }, [data]);

  const handleSaveClick = async () => {
    await shippingComplete(targetShippingSeq);
    setComplete(true);
  };
  const handleDownloadClick = async () => {
    const res = await shippingImportExcel(targetShippingSeq);
    const rows = res.data.data;
    const excelContent = rows.map((r: any) => ({
      주문번호: r.scan_code,
      주문일: r.order_date,
      회사코드: r.vender_code,
      '주문서 최저온도': r.temp_min,
      '주문서 최고온도': r.temp_max,
      수량: r.amount,
      제조번호: r.pnumber,
      제조일자: r.manufacture,
      유효기한: r.expiration,
      제품코드: r.product_id,
      제품명: r.product_name,
      규격: r.C,
      제조사: r.company,
      '제조사 주소': r.company_address,
      '제품 최저온도': r.product_temp_min,
      '제품 최고온도': r.product_temp_max,
      '거래처 코드': r.customer_id,
      거래처명: r.customer_nm,
      '거래처 사업자 번호': r.customer_code,
      '거래처 주소': r.customer_address,
      차량: r.car_number,
      배송일: r.deliver_date,
    }));
    const deliverDate = data?.shipping?.date ?? '';
    const carCount = data?.routeList?.filter((r: any) => r.dest_list?.length > 0).length ?? 0;
    const orderCount = data?.orderList?.length ?? 0;
    const destCount = data?.destList?.length ?? 0;
    const workSheet = XLSX.utils.json_to_sheet(excelContent);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, '배차결과');
    XLSX.writeFile(workBook, `ai_shipping_${deliverDate}_${orderCount}_${destCount}_${carCount}.xlsx`);
  };
  return (
    <>
      <BasicInfo />
      <ButtonAreaWrap>
        {complete ? (
          <Button
            variant="contained"
            size="large"
            color="primary"
            sx={{ width: '8rem' }}
            onClick={handleDownloadClick}
            startIcon={<DownloadIcon />}
          >
            다운로드
          </Button>
        ) : (
          <Button
            variant="contained"
            size="large"
            disabled={!(basicInfo?.carCount > 0) || changeCarList.length !== 0 || data?.orderList?.some((o: any) => o.order_state === 'Picking')}
            color="success"
            sx={{ width: '8rem', '&.Mui-disabled': { background: '#aaaaaa' } }}
            onClick={handleSaveClick}
            startIcon={<BeenhereIcon />}
          >
            확정
          </Button>
        )}
      </ButtonAreaWrap>
      {destDetail && <DestDetailPop />}
      <AllCarList />
      <AllDestList />
      <AllOrderList />
      <AllNotAssignList />
    </>
  );
}
